import { render } from "./TopicListPage.vue?vue&type=template&id=18055b91&ts=true"
import script from "./TopicListPage.vue?vue&type=script&lang=ts"
export * from "./TopicListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__